import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  city: string;
  country: string;
};
const BUYERS: Buyer[] = [{
  name: 'Michael',
  city: 'Toronto',
  country: 'Canada'
}, {
  name: 'James',
  city: 'Manchester',
  country: 'United Kingdom'
}, {
  name: 'Liam',
  city: 'Auckland',
  country: 'New Zealand'
}, {
  name: 'Daniel',
  city: 'Sydney',
  country: 'Australia'
}, {
  name: 'Andrew',
  city: 'Vancouver',
  country: 'Canada'
}, {
  name: 'Oliver',
  city: 'London',
  country: 'United Kingdom'
}, {
  name: 'Ethan',
  city: 'Wellington',
  country: 'New Zealand'
}, {
  name: 'Thomas',
  city: 'Melbourne',
  country: 'Australia'
}, {
  name: 'Lucas',
  city: 'Calgary',
  country: 'Canada'
}, {
  name: 'Ryan',
  city: 'Edinburgh',
  country: 'United Kingdom'
}, {
  name: 'Jack',
  city: 'Christchurch',
  country: 'New Zealand'
}, {
  name: 'Peter',
  city: 'Brisbane',
  country: 'Australia'
}, {
  name: 'Stefan',
  city: 'Montreal',
  country: 'Canada'
}, {
  name: 'Harry',
  city: 'Birmingham',
  country: 'United Kingdom'
}, {
  name: 'Mason',
  city: 'Perth',
  country: 'Australia'
}];
const MINUTES = [2, 3, 5, 7, 8, 11, 14, 18];
export function PurchasePopup() {
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [dismissed, setDismissed] = useState<boolean>(false);
  useEffect(() => {
    if (dismissed) return;
    let hideId = 0;
    const showId = window.setInterval(() => {
      setVisible(true);
      hideId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % BUYERS.length);
      }, 5000);
    }, 9000);
    const firstId = window.setTimeout(() => setVisible(true), 3500);
    return () => {
      window.clearInterval(showId);
      window.clearTimeout(hideId);
      window.clearTimeout(firstId);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div role="status" aria-live="polite" className="animate-pop-in fixed bottom-3 left-3 z-50 max-w-[270px] rounded-xl border-2 border-urgent bg-white p-2.5 pr-7 shadow-xl shadow-brand-dark/25 sm:max-w-[300px]" data-id="element-181" data-mp="2ap3037xgwma4">
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-1 top-1 rounded-full p-1 text-softgray transition hover:bg-ivory hover:text-charcoal" data-id="element-182" data-mp="2knacddgtag5s">
        <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-183" data-mp="1wwwugfrxxxox" />
      </button>

      <div className="flex items-start gap-2" data-id="element-184" data-mp="1wutvv7cq2w8l">
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-185" data-mp="21v85gttz2e8q">
          <CheckCircle2Icon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-186" data-mp="26o1738u596gl" />
        </span>
        <div data-id="element-187" data-mp="196j20o5g1wtt">
          <p className="font-head text-[12px] font-semibold leading-tight text-charcoal" data-id="element-188" data-mp="196sow2v6znva">
            {buyer.name} from {buyer.city}, {buyer.country}
          </p>
          <p className="text-[11px] leading-snug text-softgray" data-id="element-189" data-mp="3rhgjd23gpwy3">
            just purchased <span className="font-semibold text-brand" data-id="element-190" data-mp="3nfd565pese94">Padel Coach Pro™</span>
          </p>
          <p className="mt-0.5 text-[10px] text-softgray" data-id="element-191" data-mp="3ndihwkqo0a1v">{minutes} minutes ago · Verified</p>
        </div>
      </div>
    </div>;
}